import cancelarteHorizontal from '../../images/logotypes/cancelarte_horizontal_color.svg';
import './Header.css';
import { IoLogoWhatsapp } from 'react-icons/io';


const Header = ({refs}) => {
    const telefono = "+5491162787796";

    const scrollToSection = (num, offset = 80) => {
        window.scrollTo({
          top: refs[num].current.offsetTop - offset,
          behavior: 'smooth',
        });
    };

    const onClickWhatsapp = () => {
        const url = `https://api.whatsapp.com/send?phone=${telefono}&text=Hola quiero saber mas sobre sus servicios`;
        window.open(url, "_blank");
    };
  

    return (
        <nav className="navbar navbar-expand-lg bg-transparent">
            <div className="container-fluid background-color-container">
                <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarSupportedContent" 
                    aria-controls="navbarSupportedContent" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse row" id="navbarSupportedContent">
                    <div className='col-4'>
                        <ul className="navbar-nav mb-2 mb-lg-0">
                            <li className="nav-item" onClick={() => scrollToSection(1, 90)}>
                                <a className="nav-link">Servicios</a>
                            </li>
                            <li className="nav-item" onClick={() => scrollToSection(2, 69)}>
                                <a className="nav-link">Ventajas</a>
                            </li>
                            <li className="nav-item" onClick={() => scrollToSection(3, 50)}>
                                <a className="nav-link">Nosotros</a>
                            </li>
                            <li className="nav-item" onClick={() => scrollToSection(4, 65)}>
                                <a className="nav-link">Contacto</a>
                            </li>
                        </ul>
                    </div>
                    <div className="navbar_logo col-4 d-flex justify-content-center">
                        <img src={cancelarteHorizontal} onClick={() => scrollToSection(0)} alt="logo" />
                    </div>
                    <div className="navbar_contact_button_div col-4 d-flex justify-content-end">
                        <button className="navbar_contact_button" onClick={() => onClickWhatsapp()}><IoLogoWhatsapp className="navbar_whatsapp_icon" size={25}/> Contáctanos</button>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Header